module.exports = __webpack_public_path__ + "img/cream-of-potato-soup.10e9359e.jpg";